<template>
  <div class="page-shell">
    <BaseConhecimento />
  </div>
</template>

<script>
import BaseConhecimento from "../components/BaseConhecimento.vue";

export default {
  name: "Ajuda",
  components: {
    BaseConhecimento,
  },
};
</script>
